module.exports = __webpack_public_path__ + "img/bg-frase.9b8568cb.webp";